module.exports = __webpack_public_path__ + "static/media/bienfaits.d702b00c.JPG";